import React, { forwardRef } from 'react';
import clsx from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, leftIcon, className, id, ...props }, ref) => {
    const inputId = id ?? `input-${Math.random().toString(36).slice(2)}`;
    return (
      <div className="input-wrapper">
        {label && <label htmlFor={inputId} className="input-label">{label}</label>}
        <div className={clsx('input-field', error && 'input-field--error')}>
          {leftIcon && <span className="input-field__icon">{leftIcon}</span>}
          <input id={inputId} ref={ref} className={clsx('input-field__input', leftIcon && 'input-field__input--padded', className)} {...props} />
        </div>
        {error && <p className="input-error">{error}</p>}
      </div>
    );
  }
);
Input.displayName = 'Input';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, error, options, id, className, ...props }: SelectProps) {
  const selectId = id ?? `select-${Math.random().toString(36).slice(2)}`;
  return (
    <div className="input-wrapper">
      {label && <label htmlFor={selectId} className="input-label">{label}</label>}
      <select id={selectId} className={clsx('input-field__select', error && 'input-field--error', className)} {...props}>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {error && <p className="input-error">{error}</p>}
    </div>
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export function Textarea({ label, error, id, className, ...props }: TextareaProps) {
  const textareaId = id ?? `textarea-${Math.random().toString(36).slice(2)}`;
  return (
    <div className="input-wrapper">
      {label && <label htmlFor={textareaId} className="input-label">{label}</label>}
      <textarea id={textareaId} className={clsx('input-field__textarea', error && 'input-field--error', className)} {...props} />
      {error && <p className="input-error">{error}</p>}
    </div>
  );
}
